/**
 * Status Pending Media Key Status.
 *
 *
 * @beta
 */
export const STATUS_PENDING = 'status-pending'
